import { render, staticRenderFns } from "./jifen.vue?vue&type=template&id=0485178a&scoped=true&"
import script from "./jifen.vue?vue&type=script&lang=js&"
export * from "./jifen.vue?vue&type=script&lang=js&"
import style0 from "./jifen.vue?vue&type=style&index=0&id=0485178a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0485178a",
  null
  
)

export default component.exports